export const automationFr = {
  title: "Automatisations",
  read_only:
    "Lecture seule : voici ce qui se passe automatiquement après chaque résultat.",
  tabs: { rules: "Règles", history: "Historique" },
  new_rule: "Nouvelle règle",
  enable: "Activer %{name}",
  move_up: "Monter %{name}",
  move_down: "Descendre %{name}",
  none: "Aucune règle.",
  columns: {
    name: "Nom",
    trigger: "Déclencheur",
    last_run: "Dernière exécution",
    runs: "Exécutions (7 j)",
    failures: "Échecs (7 j)",
    status: "Statut",
    error: "Code d'erreur",
    date: "Date",
    details: "Détails",
    enabled: "Active",
    order: "Ordre",
  },
  triggers: {
    call_outcome: "Résultat d'appel",
    deal_stage_changed: "Étape de deal modifiée",
    deal_created: "Deal créé",
    no_activity: "Aucune activité",
    email_event: "Événement courriel",
    meeting_note_matched: "Notes de réunion associées",
    schedule: "Horaire",
  },
  statuses: {
    done: "Terminé",
    failed: "Échec",
    skipped: "Ignoré",
    running: "En cours",
    scheduled: "Planifié",
    cancelled: "Annulé",
    planned: "Prévu",
  },
  field_groups: {
    call: "Appel",
    company: "Entreprise",
    rep: "Représentant",
    deal: "Deal",
    email: "Courriel",
    meeting: "Réunion",
    event: "Événement",
  },
  editor: {
    title_new: "Nouvelle règle",
    name: "Nom",
    description: "Description",
    trigger: "Déclencheur",
    conditions: "Conditions",
    actions: "Actions",
    group_mode: "Mode du groupe",
    all: "Toutes les conditions",
    any: "Au moins une condition",
    add_condition: "Ajouter une condition",
    add_group: "Ajouter un groupe",
    condition_n: "Condition %{n}",
    group_n: "Groupe %{n}",
    remove_condition: "Retirer la condition %{n}",
    remove_group: "Retirer le groupe %{n}",
    field: "Champ",
    op: "Opérateur",
    value: "Valeur",
    value_list_hint: "Valeurs séparées par des virgules",
    action_n: "Action %{n}",
    remove_action: "Retirer l'action %{n}",
    move_action_up: "Monter l'action %{n}",
    move_action_down: "Descendre l'action %{n}",
    add_action: "Ajouter une action",
    action_type: "Type d'action",
    save: "Enregistrer",
    saved: "Règle enregistrée.",
    deleted: "Règle supprimée.",
    delete: "Supprimer la règle",
    close: "Fermer",
    test: "Tester la règle",
    no_activity_days: "Jours sans activité",
    no_activity_entity: "Entité",
    stages: "Étapes",
    cron: "Expression cron",
    trigger_reset_confirm:
      "Passer à « %{trigger} » efface les conditions actuelles. Continuer ?",
    trigger_reset_ok: "Changer le déclencheur",
    cancel: "Annuler",
  },
  params: {
    business_days: "Jours ouvrables",
    at: "Heure",
    status: "Statut",
    days: "Jours",
    task_type: "Type de tâche",
    text: "Texte",
    due: "Échéance",
    assignee: "Responsable",
    stage: "Étape",
    name_template: "Modèle du nom",
    amount_from: "Montant depuis",
    text_template: "Modèle du texte",
    sequence_id: "Séquence (id)",
    reason: "Raison",
    template: "Modèle",
    via: "Envoi par",
    to: "Destinataire",
    from: "Source",
    who: "Destinataire",
    message_template: "Modèle du message",
    channels: "Canaux",
    trigger: "Moment",
  },
  delay: {
    label: "Quand",
    now: "Immédiatement",
    business_days: "Dans N jours ouvrables à HH:MM",
    minutes: "Dans N minutes",
    hours: "Dans N heures",
    before: "N heures avant la démo",
    from: "À la date du rappel",
    n: "N",
    at: "Heure",
  },
  ops: {
    eq: "est",
    neq: "n'est pas",
    in: "est parmi",
    nin: "n'est pas parmi",
    gt: ">",
    gte: "≥",
    lt: "<",
    lte: "≤",
    exists: "existe",
    not_exists: "n'existe pas",
    contains: "contient",
    days_since_gte: "depuis au moins N jours",
    matches: "correspond à",
  },
  actions: {
    set_callback: "Planifier un rappel",
    set_prospect_status: "Changer le statut",
    cool_down: "Mettre en pause",
    create_task: "Créer une tâche",
    create_deal: "Créer un deal",
    move_deal: "Changer l'étape du deal",
    add_note: "Ajouter une note",
    enroll_sequence: "Inscrire à une séquence",
    stop_sequences: "Arrêter les séquences",
    send_email: "Envoyer un courriel",
    create_calendar_event: "Créer un événement Outlook",
    notify_teams: "Publier dans Teams",
    notify_user: "Notifier un utilisateur",
    suppress: "Ajouter à la liste Ne pas contacter",
    ai_draft: "Préparer un brouillon IA",
  },
  dry_run: {
    title: "Test à blanc",
    event: "Événement",
    pick: "Choisir un événement récent",
    matched: "Conditions satisfaites",
    not_matched: "Conditions non satisfaites",
    trace: "Conditions évaluées",
    nothing: "Aucune action",
    skipped: "ignorée (%{reason})",
    due: "prévue le %{date}",
    none_events: "Aucun événement récent pour ce déclencheur.",
    no_write: "Rien n'est enregistré ni exécuté.",
  },
  issue_at: {
    action: "Action %{n}",
    conditions: "Conditions",
    rule: "Règle",
  },
  errors: {
    required: "Champ obligatoire.",
    name_required: "Le nom est obligatoire.",
    invalid_rule: "Règle invalide.",
    conditions_required:
      "Les conditions sont obligatoires ({} signifie « toujours »).",
    too_deep: "Deux niveaux de groupes au maximum.",
    unknown_op: "Opérateur inconnu.",
    invalid_regex: "Expression régulière invalide.",
    unsafe_regex:
      "Expression régulière risquée (quantificateurs imbriqués). Simplifiez-la.",
    actions_not_array: "La liste des actions est invalide.",
    unknown_action: "Action inconnue.",
    invalid_business_days:
      "Le nombre de jours ouvrables doit être un entier entre 0 et 366.",
    unknown_template: "Modèle de courriel inconnu.",
    save_failed: "Impossible d'enregistrer la règle.",
  },
  warnings: {
    unknown_field: "Champ inconnu pour ce déclencheur.",
    prefer_graph: "Préférez Graph pour les courriels individuels.",
  },
  history: {
    filter_rule: "Règle",
    filter_status: "Statut",
    all: "Tous",
    none: "Aucune exécution.",
    hide: "Masquer",
  },
};
